import { useQuery } from "@tanstack/react-query";
import { ALERT_KEYS } from "./alert.keys";
import { GetAlertParams } from "./alert.type";
import { alertServices } from "./alert.service";

export const useGetAlerts = (params?: GetAlertParams) => {
  return useQuery({
    queryKey: ALERT_KEYS.GET_ALERTS(params),
    queryFn: () => alertServices.getAlerts(params),
  });
};
